import { useAtom } from "jotai";
import { useI18N } from "common/hooks";
import { drawerMenuOpenAtom } from "@/store/atoms";
import {
  publicFaqUrl,
  publicAboutUrl,
  publicPrivacyUrl,
  publicTermsUrl,
  publicTaggingInformationUrl,
} from "common/config";
import { useGetInTouchModal } from "@/hooks/useGetInTouchModal";
import { useSelectedVenue } from "@/hooks/useSelectedVenue";
import {
  savedPlaceByUserIdToViewAtom,
  savedPlaceIdToViewAtom,
  venueDetailsOpenedAtom,
} from "@/state/atoms";
import { onboardingCompletedAtom } from "@/store/atoms";
import AnalyticsService from "@/services/analytics";

function GetNavigationPages(
  isLoggedIn,
  setIsModalOpen,
  setIsOnboardingModalOpen,
  setOnboardingCurrentScreen,
) {
  const i18n = useI18N();
  const { showGetInTouchModal } = useGetInTouchModal();

  const handleOpenFeedbackModal = () => {
    console.log("in handleOpenFeedbackModal");
    showGetInTouchModal();
  };

  const handleOpenOnboardingSliderModal = () => {
    console.log("in GNP handleOpenOnboardingSliderModal");
    setOnboardingCurrentScreen(0);
    setIsOnboardingModalOpen(true);
    setIsOnboardingCompleted(false);
  };

  const [, setDrawerMenuOpen] = useAtom(drawerMenuOpenAtom);

  const toggleDrawerMenu = () => {
    setDrawerMenuOpen((drawerMenuOpen) => !drawerMenuOpen);
  };

  const { setSelectedVenue } = useSelectedVenue();
  const [, setIsVenueDetailsOpen] = useAtom(venueDetailsOpenedAtom);
  const [, setSavedPlaceIdToView] = useAtom(savedPlaceIdToViewAtom);
  const [, setSavedPlaceByUserIdToView] = useAtom(savedPlaceByUserIdToViewAtom);
  const [, setIsOnboardingCompleted] = useAtom(onboardingCompletedAtom);

  const toggleDrawerMenuWithClear = () => {
    setSelectedVenue(null);
    setIsVenueDetailsOpen(false);

    setSavedPlaceIdToView("");
    setSavedPlaceByUserIdToView("");

    setDrawerMenuOpen((drawerMenuOpen) => !drawerMenuOpen);
  };

  return [
    {
      group: "",
      groupToShowForType: "loggedin",
      elements: [
        {
          name: `${i18n.get("yourActivity")}`,
          path: "/your-activity",
          icon: "/images/menu/user_activity.svg",
          iconDark: "/images/menu/user_activity_dark.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToProfileActivityView",
            );
            AnalyticsService.trackMx("navigatedToProfileActivityView", {});
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("yourAccessibilityProfile")}`,
          path: "/your-accessibility-profile",
          icon: "/images/menu/app_acessibility.svg",
          iconDark: "/images/menu/app_acessibility_dark.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToProfileAccessibilityView",
            );
            AnalyticsService.trackMx("navigatedToProfileAccessibilityView", {});
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("mySavedPlaces")}`,
          path: "/mysavedplaces",
          icon: "/images/Heart.svg",
          iconDark: "/images/Heart_white.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToMySavedPlaces");
            AnalyticsService.trackMx("navigatedToMySavedPlaces", {});
            toggleDrawerMenuWithClear();
          },
        },
      ],
    },
    {
      group: `${i18n.get("about")}`,
      groupToShowForType: "both",
      elements: [
        {
          name: `${i18n.get("aboutSociability")}`,
          path: "/content/about",
          icon: "/images/menu/about_sociability.svg",
          iconDark: "/images/menu/about_sociability_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicAboutUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToExternalContentPage",
            );
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicAboutUrl,
            });
            toggleDrawerMenu();
          },
        },
      ],
    },
    {
      group: `${i18n.get("helpSupport")}`,
      groupToShowForType: "both",
      elements: [
        {
          name: `${i18n.get("howTheAppWorks")}`,
          path: "",
          icon: "/images/menu/how_the_app_work.svg",
          iconDark: "/images/menu/how_the_app_work_dark.svg",
          linkToShowForType: "both",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToOnboardingSlider");
            AnalyticsService.trackMx("navigatedToOnboardingSlider", {});
            handleOpenOnboardingSliderModal();
            toggleDrawerMenu();
          },
        },

        {
          name: `${i18n.get("taggingInformation")}`,
          path: "/content/tagging-information",
          icon: "/images/menu/tagging_info.svg",
          iconDark: "/images/menu/tagging_info_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicTaggingInformationUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToExternalContentPage",
            );
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTaggingInformationUrl,
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("faqs")}`,
          path: "/content/faq",
          icon: "/images/menu/faqs.svg",
          iconDark: "/images/menu/faqs_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicFaqUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToExternalContentPage",
            );
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicFaqUrl,
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("appFeedback")}`,
          path: "#",
          icon: "/images/menu/app_feedback.svg",
          iconDark: "/images/menu/app_feedback_dark.svg",
          linkToShowForType: "both",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToAppFeedback");
            AnalyticsService.trackMx("navigatedToAppFeedback", {});
            handleOpenFeedbackModal();
            toggleDrawerMenu();
          },
        },
      ],
    },
    {
      group: `${i18n.get("legal")}`,
      groupToShowForType: "both",
      elements: [
        {
          name: `${i18n.get("privacyPolicy")}`,
          path: "/content/privacy",
          icon: "/images/menu/privacy_policy.svg",
          iconDark: "/images/menu/privacy_policy_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicPrivacyUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToExternalContentPage",
            );
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicPrivacyUrl,
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("termsOfUse")}`,
          path: "/content/terms-conditions",
          icon: "/images/menu/terms_of_use.svg",
          iconDark: "/images/menu/terms_of_use_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicTermsUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler(
              "navigatedToExternalContentPage",
            );
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTermsUrl,
            });
            toggleDrawerMenu();
          },
        },
      ],
    },
  ];
}

export default GetNavigationPages;
